import * as Portal from '@radix-ui/react-portal';

export const DebugPanelStep0 = ({
  x,
  rotateX,
  rotateY,
}: {
  x: number;
  rotateX: number;
  rotateY: number;
}) => {
  return (
    <Portal.Root>
      <div className="fixed bottom-4 left-4 right-4 z-50 flex justify-around">
        <div className="flex min-h-[120px] min-w-[300px] gap-2 rounded-lg bg-white p-4">
          <div className="text-[12px]/[14px]">
            <strong>X:</strong> {x} <br />
            <strong>Rotate X:</strong> {rotateX} <br />
            <strong>Rotate Y:</strong> {rotateY} <br />
          </div>
        </div>
      </div>
    </Portal.Root>
  );
};
